module.exports = __webpack_public_path__ + "static/media/17.6f870807.png";